"use client";
import {
  getInjectedConnector,
  hasInjectedProvider
} from "./chunk-AWVQ5XXE.js";

// src/wallets/walletConnectors/mewWallet/mewWallet.ts
var mewWallet = () => {
  return {
    id: "mew",
    name: "MEW wallet",
    iconUrl: async () => (await import("./mewWallet-4ZVF6HCJ.js")).default,
    iconBackground: "#fff",
    installed: hasInjectedProvider({ flag: "isMEWwallet" }),
    downloadUrls: {
      android: "https://play.google.com/store/apps/details?id=com.myetherwallet.mewwallet&referrer=utm_source%3Drainbow",
      ios: "https://apps.apple.com/app/apple-store/id1464614025?pt=118781877&mt=8&ct=rainbow",
      mobile: "https://mewwallet.com",
      qrCode: "https://mewwallet.com"
    },
    createConnector: getInjectedConnector({ flag: "isMEWwallet" })
  };
};

export {
  mewWallet
};
